<template>
  <div class="inventoryHeatType">
    <h1>库存 热值分类统计</h1>
    <el-form :inline="true">
      <el-form-item label="仓储">
        <el-select v-model="searchParam.storage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasStorage" active-text="区分仓储" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="库存数据刷新时间">
        <el-text v-if="data && data.now">{{ util.parseTime(data.now) }}</el-text>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" border show-summary :summary-method="summary" height="calc(100vh - 310px)">
      <el-table-column prop="storage" label="仓储" width="100" show-overflow-tooltip v-if="show.tableStorage" />
      <el-table-column prop="productHeatType" label="类型" width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.productHeatType === 'HIGH'">高卡</el-text>
          <el-text v-if="scope.row.productHeatType === 'MEDIUM'">中卡</el-text>
          <el-text v-if="scope.row.productHeatType === 'LOW'">低卡</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="库存数量" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.quantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="percentage" label="占比" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ scope.row.percentage + '%' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportPrice" label="运输单价含调度费" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productPrice" label="平均单价" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.productPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportSendAmount" label="总运费" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportSendAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productAmount" label="煤矿总价" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.productAmount) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import util from '../../utils/util'
import math from '../../utils/math'

const data = reactive({
  list: [],
  quantity: null,
  transportPrice: null,
  productPrice: null,
  transportSendAmount: null,
  productAmount: null,
})

const show = reactive({
  storageList: [],
  tableStorage: true,
})

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.storage = null
  searchParam.hasStorage = true
}
resetSearchParam()

const commitFindList = () => {
  data.list = []
  const params = {
    storage: searchParam.storage,
    hasStorage: searchParam.hasStorage
  }
  api.get('/backend/statistics/inventoryHeatType', { params: params }).then(res => {
    data.list = res.list
    data.quantity = res.quantity
    data.transportPrice = res.transportPrice
    data.productPrice = res.productPrice
    data.transportSendAmount = res.transportSendAmount
    data.productAmount = res.productAmount
    data.now = res.now
    if (searchParam.hasStorage) {
      show.tableStorage = true
    } else {
      show.tableStorage = false
    }
  })
}

const summary = () => {
  const summary = []
  summary.push('合计')
  if (show.tableStorage) {
    summary.push('')
  }
  summary.push(math.formatNumber(data.quantity))
  summary.push('')
  summary.push(math.formatNumber(data.transportPrice))
  summary.push(math.formatNumber(data.productPrice))
  summary.push(math.formatNumber(data.transportSendAmount))
  summary.push(math.formatNumber(data.productAmount))
  return summary
}

</script>

<style lang="less"></style>